<template>
    <div>
        <nav-breadcrumb :menu="[{label: userId ? '编辑分公司用户' : '新增分公司用户'}]"/>
        <el-row>
            <el-col>
                <panel label="基本信息">
                    <el-form :model="userForm" :rules="userFormRules" ref="userForm" label-width="150px">
                        <el-row :gutter="10" class="bg-purple xamhtrpg">
                            <el-col :span="24">
                                <el-form-item label="分公司：" prop="du__branchId" :rules="{required: true, message: '分公司不能为空'}" style="width: 60%">
                                    <el-select v-model="userForm.du__branchId">
                                        <el-option :label="item.label" :value="item.value" v-for="(item,idx) in branchOptions" :key="idx"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="用户名：" prop="du__userCode" :rules="{required: true, message: '用户名不能为空'}" style="width: 60%">
                                    <el-input v-model="userForm.du__userCode"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="姓名：" prop="du__userName" :rules="{required: true, message: '姓名不能为空'}" style="width: 60%">
                                    <el-input v-model="userForm.du__userName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="手机号：" prop="du__mobileNo" :rules="{required: true, message: '手机号不能为空'}" style="width: 60%">
                                    <el-input v-model="userForm.du__mobileNo"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="角色：" prop="du__roles" :rules="{required: true, message: '角色不能为空'}" style="width: 60%">
                                    <el-select v-model="userForm.du__roles">
                                        <el-option label="普通" value="普通" ></el-option>
                                        <el-option label="监管" value="监管" ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="userId==''">
                                <el-form-item label="初始密码：" prop="du__password" :rules="{required: true, message: '初始密码不能为空'}" style="width: 60%">
                                    <el-input v-model="userForm.du__password" type="password"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="状态：" prop="du__disabled" :rules="{required: true, message: '状态不能为空'}" style="width: 60%">
                                    <el-select v-model.trim="userForm.du__disabled">
                                        <el-option label="禁用" value="Y"></el-option>
                                        <el-option label="启用" value="N"></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="头像：" prop="du__pictureURL" :rules="{required: false, message: '头像不能为空'}" style="width: 60%">
                                    <image-upload  v-model="userForm.du__pictureURL" prefix="images/"></image-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div class="tr xzmt">
                            <el-button type="primary" @click="onSubmit('userForm')">确认提交</el-button>
                            <el-button @click="$router.back()">取消</el-button>
                        </div>
                    </el-form>
                </panel>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import xhr from '../../utils/xhr'
    import {xmlBuildQuery} from "../../filters/CommonActions";
    export default {
        name: "BranchUserAdd",
        data() {
            return {
                userId:this.$route.query['userId']||'',
                userForm:{},
                userFormRules:{},
                branchOptions:[],
            }
        },
        mounted() {
            if(this.userId){
                this.getData()

            }
            this.getDataBranchOfficeSelect()
        },
        methods:{
            getData:function(){
                xhr.getBranchUser({
                        'du.userId': this.userId
                    },
                    res=> {
                        try{
                            if(res.data.status == 'success') {
                                this.userForm = res.data.data
                            }
                        }catch (e) {

                        }
                    })
            },
            getDataBranchOfficeSelect: function () {
                xhr.getDataBranchOfficeSelect(
                    Object.assign({}, {}, {}),
                    res=> {
                        try {
                            this.branchOptions = res.data.data.map(item=>{
                                return {
                                    label: item.bo__branchName,
                                    value:item.bo__branchId,
                                }
                            })
                        }catch(e){

                        }
                    })

            },
            onSubmit: function (formName) {
                let userForm = this.userForm
                this.$refs[formName].validate(valid=> {
                    if (valid) {
                        userForm.du__checked = true
                        xhr.updateBranchUser(userForm, res=> {
                            try {
                                if (res.data.status == 'success') {
                                    this.$router.push({
                                        name: 'BranchUserListView'
                                    })
                                }
                            } catch (e) {
                            }
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/branchoffice/BranchUserAdd.vue